import { useEffect } from 'react';
import { AbortControllerRef } from '@interfaces/timeline';

interface UseBatchTimelineEffectsParams {
  // Refs for cleanup
  abortControllerEvents?: AbortControllerRef;
  abortControllerAlarmEvent?: AbortControllerRef;
  abortControllerCountsSearch?: AbortControllerRef;
  abortControllerEventStart?: AbortControllerRef;
  abortControllerEventEnd?: AbortControllerRef;
  abortControllerNcFile?: AbortControllerRef;

  // Batch data
  productionBatchId?: string | number;
  productionBatchStartDateForDisplay: string | null;
  productionBatchEndDateForDisplay: string | null;
  updatedMachineEventsTimelineHash?: string | null;

  // Functions
  fetchData?: (params?: { start?: string; end?: string }) => Promise<void>;
}

export const useBatchTimelineEffects = ({
  abortControllerEvents,
  abortControllerAlarmEvent,
  abortControllerCountsSearch,
  abortControllerEventStart,
  abortControllerEventEnd,
  abortControllerNcFile,
  productionBatchId,
  productionBatchStartDateForDisplay,
  productionBatchEndDateForDisplay,
  updatedMachineEventsTimelineHash,
  fetchData,
}: UseBatchTimelineEffectsParams) => {
  // Cleanup effect for abort controllers
  useEffect(() => {
    return () => {
      abortControllerEvents?.current?.abort();
      abortControllerAlarmEvent?.current?.abort();
      abortControllerCountsSearch?.current?.abort();
      abortControllerEventStart?.current?.abort();
      abortControllerEventEnd?.current?.abort();
      abortControllerNcFile?.current?.abort();
    };
  }, []);

  // Reload data on timeline hash change
  useEffect(() => {
    (async () => {
      if (productionBatchId == null || productionBatchStartDateForDisplay == null || productionBatchEndDateForDisplay == null) return;
      if (fetchData) {
        await fetchData({});
      }
    })();
  }, [updatedMachineEventsTimelineHash]);

  // Fetch data when production batch or dates change
  useEffect(() => {
    (async () => {
      if (productionBatchId == null || productionBatchStartDateForDisplay == null || productionBatchEndDateForDisplay == null) return;
      if (fetchData) {
        await fetchData({ start: productionBatchStartDateForDisplay, end: productionBatchEndDateForDisplay });
      }
    })();
  }, [productionBatchId, productionBatchStartDateForDisplay, productionBatchEndDateForDisplay]);
};
